// source: enum.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();
goog.exportSymbol('proto.manabie.bob.AskDuration', null, global);
goog.exportSymbol('proto.manabie.bob.AssignmentStatus', null, global);
goog.exportSymbol('proto.manabie.bob.CoachAutoEvent', null, global);
goog.exportSymbol('proto.manabie.bob.CodOrderStatus', null, global);
goog.exportSymbol('proto.manabie.bob.CodOrderTransitionAction', null, global);
goog.exportSymbol('proto.manabie.bob.Country', null, global);
goog.exportSymbol('proto.manabie.bob.NotificationType', null, global);
goog.exportSymbol('proto.manabie.bob.OrderStatus', null, global);
goog.exportSymbol('proto.manabie.bob.OrderTransitionAction', null, global);
goog.exportSymbol('proto.manabie.bob.PaymentGateway', null, global);
goog.exportSymbol('proto.manabie.bob.PaymentMethod', null, global);
goog.exportSymbol('proto.manabie.bob.PaymentStatus', null, global);
goog.exportSymbol('proto.manabie.bob.PlanPrivilege', null, global);
goog.exportSymbol('proto.manabie.bob.QuestionStatus', null, global);
goog.exportSymbol('proto.manabie.bob.QuestionTransition', null, global);
goog.exportSymbol('proto.manabie.bob.Subject', null, global);
goog.exportSymbol('proto.manabie.bob.SubscriptionStatus', null, global);
goog.exportSymbol('proto.manabie.bob.TopicStatus', null, global);
goog.exportSymbol('proto.manabie.bob.TopicType', null, global);
goog.exportSymbol('proto.manabie.bob.TutorStatus', null, global);
goog.exportSymbol('proto.manabie.bob.UploadType', null, global);
goog.exportSymbol('proto.manabie.bob.UserGroup', null, global);
goog.exportSymbol('proto.manabie.bob.UserNotificationStatus', null, global);
/**
 * @enum {number}
 */

proto.manabie.bob.Country = {
  COUNTRY_NONE: 0,
  COUNTRY_MASTER: 1,
  COUNTRY_VN: 2,
  COUNTRY_ID: 3
};
/**
 * @enum {number}
 */

proto.manabie.bob.Subject = {
  SUBJECT_NONE: 0,
  SUBJECT_MATHS: 1,
  SUBJECT_BIOLOGY: 2,
  SUBJECT_PHYSICS: 3,
  SUBJECT_CHEMISTRY: 4,
  SUBJECT_GEOGRAPHY: 5,
  SUBJECT_ENGLISH: 6,
  SUBJECT_ENGLISH_2: 7
};
/**
 * @enum {number}
 */

proto.manabie.bob.TopicType = {
  TOPIC_TYPE_NONE: 0,
  TOPIC_TYPE_LEARNING: 1,
  TOPIC_TYPE_PRACTICAL: 2,
  TOPIC_TYPE_EXAM: 3
};
/**
 * @enum {number}
 */

proto.manabie.bob.UserNotificationStatus = {
  USER_NOTIFICATION_STATUS_NONE: 0,
  USER_NOTIFICATION_STATUS_NEW: 1,
  USER_NOTIFICATION_STATUS_SEEN: 2,
  USER_NOTIFICATION_STATUS_READ: 3,
  USER_NOTIFICATION_STATUS_FAILED: 4
};
/**
 * @enum {number}
 */

proto.manabie.bob.NotificationType = {
  NOTIFICATION_TYPE_PROMO_CODE: 0
};
/**
 * @enum {number}
 */

proto.manabie.bob.UploadType = {
  UPLOAD_TYPE_AVATAR: 0,
  UPLOAD_TYPE_CHAT: 1
};
/**
 * @enum {number}
 */

proto.manabie.bob.PaymentStatus = {
  PAYMENT_STATUS_ON_TRIAL: 0,
  PAYMENT_STATUS_EXPIRED_TRIAL: 1,
  PAYMENT_STATUS_PAID: 2,
  PAYMENT_STATUS_LATE_PAYMENT: 3
};
/**
 * @enum {number}
 */

proto.manabie.bob.AskDuration = {
  THIS_DAY: 0,
  THIS_WEEK: 1,
  THIS_MONTH: 2,
  THIS_YEAR: 3
};
/**
 * @enum {number}
 */

proto.manabie.bob.QuestionStatus = {
  QUESTION_STATUS_WAITING_FOR_ASSIGN: 0,
  QUESTION_STATUS_ASSIGNED: 1,
  QUESTION_STATUS_MARKED_AS_RESOLVED: 2,
  QUESTION_STATUS_MARKED_AS_INVALID: 3,
  QUESTION_STATUS_INVALID: 4,
  QUESTION_STATUS_SOLVED: 5,
  QUESTION_STATUS_EXPIRED_SOLVED: 6,
  QUESTION_STATUS_RATED: 7,
  QUESTION_STATUS_ARCHIVED: 8
};
/**
 * @enum {number}
 */

proto.manabie.bob.TutorStatus = {
  TUTOR_STATUS_NONE: 0,
  TUTOR_STATUS_ONLINE: 1,
  TUTOR_STATUS_OFFLINE: 2
};
/**
 * @enum {number}
 */

proto.manabie.bob.TopicStatus = {
  TOPIC_STATUS_NONE: 0,
  TOPIC_STATUS_DRAFT: 1,
  TOPIC_STATUS_PUBLISHED: 2
};
/**
 * @enum {number}
 */

proto.manabie.bob.OrderStatus = {
  ORDER_STATUS_NONE: 0,
  ORDER_STATUS_WAITING_FOR_PAYMENT: 1,
  ORDER_STATUS_SUCCESSFULLY: 2,
  ORDER_STATUS_FAILED: 3,
  ORDER_STATUS_CANCELED: 4,
  ORDER_STATUS_ENDED: 5,
  ORDER_STATUS_PROCESSING_PAYMENT: 6,
  ORDER_STATUS_DELETED: 7
};
/**
 * @enum {number}
 */

proto.manabie.bob.OrderTransitionAction = {
  ORDER_TRANSITION_NONE: 0,
  ORDER_TRANSITION_PROCESS_PAYMENT: 1,
  ORDER_TRANSITION_COMPLETE: 2,
  ORDER_TRANSITION_FAIL: 3,
  ORDER_TRANSITION_CANCEL: 4,
  ORDER_TRANSITION_CLOSE: 5,
  ORDER_TRANSITION_DELETE: 6
};
/**
 * @enum {number}
 */

proto.manabie.bob.QuestionTransition = {
  QUESTION_TRANSITION_ASSIGN: 0,
  QUESTION_TRANSITION_MARKED_AS_RESOLVED: 1,
  QUESTION_TRANSITION_MARKED_AS_INVALID: 2,
  QUESTION_TRANSITION_AGREE_INVALID: 3,
  QUESTION_TRANSITION_DISAGREE_INVALID: 4,
  QUESTION_TRANSITION_AGREE_RESOLVED: 5,
  QUESTION_TRANSITION_DISAGREE_RESOLVED: 6,
  QUESTION_TRANSITION_TIME_OUT_SOLVED: 7,
  QUESTION_TRANSITION_RATE: 8,
  QUESTION_TRANSITION_ARCHIVED: 9
};
/**
 * @enum {number}
 */

proto.manabie.bob.CoachAutoEvent = {
  COACH_AUTO_EVENT_FINISH_FIRST_LO: 0,
  COACH_AUTO_EVENT_FINISH_FIRST_TOPIC: 1
};
/**
 * @enum {number}
 */

proto.manabie.bob.PaymentGateway = {
  GATEWAY_NONE: 0,
  GATEWAY_ASIAPAY: 1,
  GATEWAY_ONEPAY: 2,
  GATEWAY_MOMO: 3,
  GATEWAY_ZALO: 4,
  GATEWAY_GRAB: 5,
  GATEWAY_GHN: 6,
  GATEWAY_IOS: 7
};
/**
 * @enum {number}
 */

proto.manabie.bob.CodOrderTransitionAction = {
  COD_ORDER_TRANSITION_NONE: 0,
  COD_ORDER_TRANSITION_COMPLETE: 1,
  COD_ORDER_TRANSITION_CANCEL: 2
};
/**
 * @enum {number}
 */

proto.manabie.bob.CodOrderStatus = {
  COD_ORDER_STATUS_NONE: 0,
  COD_ORDER_STATUS_PENDING: 1,
  COD_ORDER_STATUS_CANCELED: 2,
  COD_ORDER_STATUS_SUCCESSFULLY: 3
};
/**
 * @enum {number}
 */

proto.manabie.bob.SubscriptionStatus = {
  SUBSCRIPTION_STATUS_NONE: 0,
  SUBSCRIPTION_STATUS_ACTIVE: 1,
  SUBSCRIPTION_STATUS_DISABLED: 2
};
/**
 * @enum {number}
 */

proto.manabie.bob.PlanPrivilege = {
  CAN_ACCESS_LEARNING_TOPICS: 0,
  CAN_ACCESS_PRACTICE_TOPICS: 1,
  CAN_ACCESS_MOCK_EXAMS: 2,
  CAN_ACCESS_ALL_LOS: 3,
  CAN_ACCESS_SOME_LOS: 4,
  CAN_WATCH_VIDEOS: 5,
  CAN_READ_STUDY_GUIDES: 6,
  CAN_SKIP_VIDEOS: 7
};
/**
 * @enum {number}
 */

proto.manabie.bob.PaymentMethod = {
  PAYMENT_METHOD_NONE: 0,
  PAYMENT_METHOD_ATM: 1,
  PAYMENT_METHOD_CREDIT_DEBIT_CARD: 2,
  PAYMENT_METHOD_COD: 3,
  PAYMENT_METHOD_BANK_TRANSFER: 4,
  PAYMENT_METHOD_IAP: 5
};
/**
 * @enum {number}
 */

proto.manabie.bob.UserGroup = {
  USER_GROUP_NONE: 0,
  USER_GROUP_STUDENT: 1,
  USER_GROUP_COACH: 2,
  USER_GROUP_TUTOR: 3,
  USER_GROUP_STAFF: 4,
  USER_GROUP_ADMIN: 5,
  USER_GROUP_TEACHER: 6,
  USER_GROUP_PARENT: 7,
  USER_GROUP_CONTENT_ADMIN: 8,
  USER_GROUP_CONTENT_STAFF: 9,
  USER_GROUP_SALES_ADMIN: 10,
  USER_GROUP_SALES_STAFF: 11,
  USER_GROUP_CS_ADMIN: 12,
  USER_GROUP_CS_STAFF: 13,
  USER_GROUP_SCHOOL_ADMIN: 14,
  USER_GROUP_SCHOOL_STAFF: 15
};
/**
 * @enum {number}
 */

proto.manabie.bob.AssignmentStatus = {
  ASSIGNMENT_STATUS_NONE: 0,
  ASSIGNMENT_STATUS_STARTED: 1,
  ASSIGNMENT_STATUS_UPCOMING: 2
};
goog.object.extend(exports, proto.manabie.bob);